import React from 'react'
import * as _ from 'recompose'
import { connect } from 'react-redux'
import { setPaymentData, /*removeUserPayment*/ } from '../../../store/reducers/paymentMethods'
//import { setBidData } from '../../../store/reducers/lots/bid'
import { /*FormattedMessage,*/ injectIntl } from 'react-intl'
import { compose, lifecycle, /*branch*/ } from 'recompose'
//import { setUserSettings } from '../../../store/reducers/auth'

// const formatExpiry = str => str.substring(4, 6) + '/' + str.substring(2, 4)

const GiftCard = ({
  //data,
  //empty = false,
  selected = false,
  onSelect,
  pin, number, setData, input1, input2, focus, stay, bidInputFocus, useGiftCard, setGiftCard, /*use,*/ giftCardChecked,
}) =>  {
let noAutoFocus = true//если пользователь кликнул на ввод суммы ставки, уберем фокус с input ввода данных карты
if (!bidInputFocus)
  noAutoFocus = false

return(
  <div className='PaymentGiftCards__item'>
    {/*<div className={`PaymentCard ${(selected || stay) && 'PaymentCard_selected'} `} onClick={onSelect}>
      
        <div className='PaymentCard__header' onClick={onSelect}>

          <div className='GiftCards__row' style={{ width: "100%" }} onClick={input1}>
            <p className='Text'>
              <input
                type='number'
                className="Form__field Form__field-number PaymentCard__expiry PaymentCard__input"
                value={number}
                placeholder="Номер карты"
                onInput={!stay && setData('number')}
                ref={el => { !noAutoFocus && focus == 'focus1' && ((el && el.focus) && el.focus())}}
                key='1'
                onClick={input1}
              />
            </p>
          </div>

        </div>
        <input
          type='number'
          className="Form__field Form__field-number PaymentCard__number PaymentCard__input"
          value={pin}
          placeholder="Пин код"
          onInput={!stay && setData('pin')}
          key='2'
          ref={el => { !noAutoFocus && focus == 'focus2' && ((el && el.focus) && el.focus())}}
          onClick={input2}
        />
</div>*/}

<div className="GiftCardPayment__row">
        <div className="GiftCardPayment__number">
          <input
            type='number'
                className="Form__field Form__field-number PaymentCard__expiry PaymentCard__input"
                value={number}
                placeholder="№ сертификата"
                onInput={!stay && setData('number')}
                ref={el => { !noAutoFocus && focus === 'focus1' && ((el && el.focus) && el.focus())}}
                key='1'
                onClick={input1}
                disabled={giftCardChecked}
          />
        </div>
        <div className="GiftCardPayment__pin">
          <input
            type='number'
            className="Form__field Form__field-number PaymentCard__number PaymentCard__input"
            value={pin}
            placeholder="Пин-код"
            onInput={!stay && setData('pin')}
            key='2'
            ref={el => { !noAutoFocus && focus === 'focus2' && ((el && el.focus) && el.focus())}}
            onClick={input2}
            disabled={giftCardChecked}
          />
        </div>
        <div className="GiftCardPayment__use" onClick={setGiftCard}>
          {!giftCardChecked ? 'Использовать' : 'Изменить'}
        </div>
      </div>
  </div>
)}

const mapState = (state, { currentMethod, paymentId }) => {
  
  const data = state.paymentMethods.data

  return ({
    partPay: state.lots.bid.data.giftcardData.partPay,
    currentPaymentMethod: data.paymentMethod,
    getGiftCard: data.getGiftCard,
    selected: (!paymentId && !data.userPaymentId && data.paymentMethod === currentMethod) || data.userPaymentId === "giftcard" 
      || state.lots.bid.data.giftcardData.partPay,
    bidValue: state.lots.bid.data.bidValue //смена суммы ставки на аукционе (для фокуса input)
  })
}

const mapDispatch = (dispatch, { paymentId = null, onChange, intl, onClickGift, setFocus, useGiftCard, giftCardChecked }) => ({
  onSelect: (e) => {
	// необходимо при выборе привязки карты, так как paymentId становится undefined, а должен быть null
	//if (paymentId == 'undefined'){
  //    paymentId = null;
	//}

    if (e && e.currentTarget && (e.currentTarget === e.target)) {
      e.target.selectionStart = 0 
      e.target.selectionEnd = 0
      //dispatch(setPaymentData('userPaymentId', 'giftcard'))
      //onChange('userPaymentId', 'giftcard')
      //onClickGift()
    }
  },
  setCardData: (data) => {
    //dispatch(setPaymentData('userPaymentId', 'giftcard'))
    //onChange('userPaymentId', 'giftcard')
    //onClickGift()
  },
  setGiftCardDispatch: (use) => {
    dispatch(setPaymentData('userPaymentId', 'giftcard'))
    onChange('userPaymentId', 'giftcard')
    onClickGift()
    useGiftCard()    
  },
  clearData: () => {
    dispatch(setPaymentData('giftcardData', {
      'number': '', 
      'pin': '', 
      'useGiftCard': false, 
      'partPay': false
    }))
  }
})

export default injectIntl(compose(
  connect(mapState, mapDispatch),
  _.withState('number', 'setNumber', ''),
  _.withState('pin', 'setPin', ''),
  _.withState('error', 'setError', false),
  _.withState('focus', 'setFocus', ''),
  _.withState('stay', 'setStay', false),
  //_.withState('use', 'setUse', true),
  _.withHandlers({
    setGiftCard: ({/*use, setUse,*/ clearData, number, pin, setNumber, setPin, setGiftCardDispatch, giftCardChecked, setGiftCardChecked}) => field => {
      if (number && pin) {
        setGiftCardDispatch();
        if(giftCardChecked){
          clearData()
          setNumber('')
          setPin('')
        }
        //setUse(!use)
        setGiftCardChecked(!giftCardChecked)
      }
    },
    setData: ({ setNumber, setPin, setCardData, sendBack, onSelect }) => field => e => {//заполнение полей ввода
      e && e.preventDefault();
      (field === 'number') ? setNumber(e.target.value) : setPin(e.target.value)
      sendBack(field, e.target.value)
      onSelect()
    },
    sendCardData: ({ number, pin, setCardData }) => field => e => {//заполнение полей ввода
        e && e.preventDefault();
        setCardData(field, e.target.value)
      },
      input1: (data) => field => {//установка фокуса на input ввода номера карты
        data.setFocus('focus1')
        data.setCardData()
        data.setBidInputFocus(false)
      },
      input2: (data) => field => {
        data.setFocus('focus2')
        data.setCardData()
        data.setBidInputFocus(false)
      }
  }),
  lifecycle({
    componentWillReceiveProps(np) {
      if (np.partPay && !this.props.partPay ){
        this.props.setStay(true)
      }
      if (np.bidInputFocus && !this.props.bidInputFocus) {
        this.props.setFocus('')
      }
    },
    componentWillUnmount () {
      this.props.clearData()
    }
  })

)(GiftCard))



// WEBPACK FOOTER //
// ./src/components/Lot/PaymentSelect/GiftCard.js